interface WizardMenuItemOutput {
	hasChildren: boolean;
	isCurrentMenu: boolean;
	wasFinished: boolean;
}
interface WizardMenuItemInput {
	childrenLength: number;
	selectedIndex: number;
	parentIndex: number;
	totalChildrenCount: number;
	totalParentWithChildrenCount: number;
}
export const useWizardMenuItemHelper = (props: WizardMenuItemInput): WizardMenuItemOutput => {
	const { childrenLength, selectedIndex, parentIndex, totalChildrenCount, totalParentWithChildrenCount } = props;

	const hasChildren = childrenLength > 0;

	const anyChildrenAreActive =
		selectedIndex >= parentIndex - totalParentWithChildrenCount + totalChildrenCount &&
		selectedIndex < parentIndex + childrenLength + totalChildrenCount - totalParentWithChildrenCount;

	const allChildrenCompleted =
		selectedIndex >= parentIndex + childrenLength + totalChildrenCount - totalParentWithChildrenCount;

	const isCurrentMenu = hasChildren
		? anyChildrenAreActive
		: selectedIndex === parentIndex + (totalChildrenCount - totalParentWithChildrenCount);

	const wasFinished =
		!isCurrentMenu &&
		(hasChildren
			? allChildrenCompleted
			: selectedIndex > parentIndex + (totalChildrenCount - totalParentWithChildrenCount));

	return {
		hasChildren,
		isCurrentMenu,
		wasFinished,
	};
};
